module.exports = __webpack_public_path__ + "icon_market_green.png?dbf051a614c33bfebfd97aeb6ef890c3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_market_green.png
// module id = 255
// module chunks = 0